module Widgets.Form.WidgetMap where

import Common

import Concur.React.DOM as D
import Data.Argonaut (Json)
import Data.Argonaut as J
import Data.Array (filter)
import Data.Array as Arr
import Data.Either (note)
import Data.FunctorWithIndex (mapWithIndex)
import Data.Traversable (traverse)
import Error (ErrorContext(..), tagContext, tagWidget)
import Foreign.Object as O
import Widgets.Form.Access (FieldAccessLevel(..))
import Widgets.Form.Class (FormContext, FormWidgetResult, fieldAccessLevel, fieldHasVisibleDescendant, formWidgetState, toWidget, getData, getId, isLeaf, setData)
import Widgets.Form.Dynamic (DynFormWidget)


-- | Mapping of widget ID to its state.
type WidgetMap = Array DynFormWidget



-- | Takes a `WidgetMap` and returns an array of the rendered widgets, which
-- | will each return a new widget map with their state changed, when their own
-- | state changes.
-- |
-- | This will also handle wrapping and returning the correct widget action for
-- | whichever widget triggers one.
renderWidgets :: FormContext -> WidgetMap -> Array (Widget HTML (FormWidgetResult WidgetMap))
renderWidgets fc wm = mapWithIndex subWidget wm
  where
    subWidget i ws = case fieldAccessLevel fc (getId ws) of
        AccessNone | isLeaf ws || not (fieldHasVisibleDescendant fc (getId ws)) ->
            formWidgetState wm <$ D.text ""
        _ -> ((\w -> fromMaybe wm $ Arr.updateAt i w wm) <$> _) <$> toWidget fc ws

-- | Turns a `WidgetMap` into a JSON object where each key is taken from each
-- | sub-field's ID, and values are determined by calling `getData` on the
-- | field.
getWMData :: FormContext -> WidgetMap -> Json
getWMData fc wm = J.fromObject $ O.fromFoldable dataFields
  where
    dataFields = filter (\(Tuple _ d) -> not $ J.isNull d) $ map field wm
    field f = Tuple (getId f) (getData fc f)

setWMData :: FormContext -> WidgetMap -> Json -> Either ErrorWrapper WidgetMap
-- This is a hack to work around the fact that PHP doesn't properly distinguish
-- between empty arrays and empty objects, even when serializing to JSON, which
-- does make that distinction.
setWMData fc wm json | json == J.fromArray [] =
    setWMData fc wm $ J.fromObject O.empty
setWMData fc wm json = do
    obj <- note (StringError "Form/subform expected object.") $ J.toObject json
    let update w = case O.lookup (getId w) obj of
            Nothing -> Right w
            Just newval | J.isNull newval -> Right w
            Just newval -> tagWidget (getId w) $ tagContext (LoadingJson "WidgetMap" newval) $
                setData fc w newval
    traverse update wm
